import React from "react";
import { teamMembers } from "../data/siteContent";

function TeamMembers() {
  return (
    <section id="team" className="team section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Team</h2>
        <p>
          Operating Software is built by a focused team that blends engineering,
          product thinking, and market understanding.
        </p>
      </div>

      <div className="container">
        <div className="row gy-4">
          {teamMembers.map((member, index) => (
            <div
              className="col-lg-6"
              data-aos="fade-up"
              data-aos-delay={`${(index + 1) * 100}`}
              key={member.name}
            >
              <article className="team-member d-flex align-items-start">
                <div className="pic">
                  <img src={member.image} className="img-fluid" alt={member.name} />
                </div>
                <div className="member-info">
                  <h4>{member.name}</h4>
                  <span>{member.role}</span>
                  <p>{member.bio}</p>
                  <div className="social">
                    {member.links.map((link) => (
                      <a
                        href={link.url}
                        key={link.url}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={`${member.name} on ${link.label}`}
                      >
                        <i className={`bi ${link.icon}`}></i>
                      </a>
                    ))}
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TeamMembers;
